import { API_BASE_URL as apiBaseUrl } from '@app/core/constants/api-base-url';

export const AlertProviderIcons: { [name: string]: string } = {
  ['worldaware']: 'https://files.topo.ai/partners/logos/Crisis24.svg',
  ['crisis24']: 'https://files.topo.ai/partners/logos/Crisis24.svg',
  ['factal']: 'https://files.topo.ai/partners/logos/Factal.svg',
  ['liferaft']: 'https://files.topo.ai/partners/logos/LifeRaft.svg',
  ['citizen']: 'https://files.topo.ai/partners/logos/Citizen.svg',
  ['isos']: 'https://files.topo.ai/partners/logos/ISOS.svg',
  ['nc4']: 'https://files.topo.ai/partners/logos/NC4.svg',
  ['control risks']: 'https://files.topo.ai/partners/logos/Control%20Risks.svg',
  ['dataminr']: 'https://files.topo.ai/partners/logos/Dataminr.svg',
  ['dragonfly']: 'https://files.topo.ai/partners/logos/Dragonfly.svg',
  ['poweroutage.us']: apiBaseUrl + '/v1/meta/markers/power-outage-small/CCEAFF/0/0/normal/power.png',
  ['samdesk']: 'https://files.topo.ai/partners/logos/Samdesk.svg',
  ['skopenow']: 'https://files.topo.ai/partners/logos/Skopenow.svg',
  ['spycloud']: 'https://files.topo.ai/partners/logos/SpyCloud.svg',
  ['tam-c']: 'https://files.topo.ai/partners/logos/TAM-C.png',
  ['titan hst']: 'https://files.topo.ai/partners/logos/Titan%20HST.svg',
  ['max security']: 'https://files.topo.ai/partners/logos/Max%20Security.svg',
  ['praedictix email']: 'https://files.topo.ai/partners/logos/Praedictix.svg',
  ['mitkat']: 'https://files.topo.ai/partners/logos/mitkat.svg',
  ['topoone earthquakes']: apiBaseUrl + '/v1/meta/markers/earthquake-magnitude-3/B46923/0/0/normal/earthquake.svg',
  ['topoone tropical-cyclones']: apiBaseUrl + '/v1/meta/markers/tropical-cyclone/CCEAFF/0/0/normal/tropical-cyclones.png',
  ['openeye cameras']: apiBaseUrl + '/v1/meta/markers/openeye/4975BA/0/0/normal/openeye.svg',
  ['onsolve']: apiBaseUrl + '/v1/meta/markers/on-solve/000000/0/0/normal/icon.svg',
  ['liveview technologies']: apiBaseUrl + '/v1/meta/markers/lvt/00A19B/0/0/normal/lvt.svg',
  ['avigilon acm alarms']: '/assets/images/avigilon.svg',
  ['genea']: '/assets/images/genea.svg',
  ['ccure']: '/assets/images/c-cure.jpg'
};
